var $d902230696bc10d9$exports = {};
$d902230696bc10d9$exports = {
    "endTime": `\u{10C}as ukon\u{10D}enia`,
    "startTime": `\u{10C}as za\u{10D}iatku`,
    "time": `\u{10C}as`
};


export {$d902230696bc10d9$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
